exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination[data-v-5cd0dc32] {\n    display: flex;\n    align-items: center;\n}\n.pagination button[data-v-5cd0dc32] {\n    margin: 0 2px;\n    padding: 5px 10px;\n    cursor: pointer;\n}\n.pagination .active[data-v-5cd0dc32] {\n    font-weight: bold;\n    color: #69BE28\n}\n", ""]);

// exports
